module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/slack-bbc2b42690229d10d0c1c542c6881e06.svg";